<div class="chartsDiv">
  @if (chartFilters().kpTo > 0 === true) {
    <app-field-view-chart-pie
      [chartTitle]="'Site Anomaly Breakdown'"
      [chartData]="siteAnomalyChartDataSignal()"
      [chartId]="'siteAnomalyBreakdownChart'"
      [dataIsLoading]="chartDataIsLoadingSignal()"
    />
    <app-field-view-chart-line
      [chartTitle]="'Depth Profile'"
      [chartData]="depthProfileChartDataSignal()"
      [chartId]="'depthProfileChart'"
      [dataIsLoading]="chartDataIsLoadingSignal()"
    />
    <app-field-view-chart-line
      [chartTitle]="'CP Profile'"
      [chartData]="cpProfileChartDataSignal()"
      [chartId]="'cpProfileChart'"
      [dataIsLoading]="chartDataIsLoadingSignal()"
    />
    <app-field-view-chart-pie
      [chartTitle]="'Event Breakdown'"
      [chartData]="eventBreakdownChartDataSignal()"
      [chartId]="'eventBreakdownChart'"
      [dataIsLoading]="chartDataIsLoadingSignal()"
    />
  } @else {
    <p>Please select a KP marker and enable survey or event layers.</p>
  }
</div>
